export function stringField(
  record: Record<string, unknown>,
  ...keys: string[]
): string {
  for (const key of keys) {
    const value = record[key];
    if (typeof value === "string" && value.trim()) {
      return value.trim();
    }
  }
  return "";
}

export function numberField(
  record: Record<string, unknown>,
  ...keys: string[]
): number | null {
  for (const key of keys) {
    const value = record[key];
    if (typeof value === "number" && Number.isFinite(value)) {
      return value;
    }
  }
  return null;
}

export function arrayField(
  record: Record<string, unknown>,
  ...keys: string[]
): unknown[] {
  for (const key of keys) {
    const value = record[key];
    if (Array.isArray(value)) {
      return value;
    }
  }
  return [];
}

export function objectField(
  record: Record<string, unknown>,
  ...keys: string[]
): Record<string, unknown> | null {
  for (const key of keys) {
    const value = record[key];
    if (value != null && typeof value === "object" && !Array.isArray(value)) {
      return value as Record<string, unknown>;
    }
  }
  return null;
}

export function stringList(value: unknown): string[] {
  if (!Array.isArray(value)) {
    return typeof value === "string" && value.trim() ? [value.trim()] : [];
  }
  return value
    .filter((item): item is string => typeof item === "string" && Boolean(item.trim()))
    .map((item) => item.trim());
}

export function conditionRecord(value: unknown): Record<string, string> {
  if (value == null || typeof value !== "object" || Array.isArray(value)) {
    return {};
  }
  const conditions: Record<string, string> = {};
  for (const [key, raw] of Object.entries(value as Record<string, unknown>)) {
    const name = key.trim();
    if (!name) {
      continue;
    }
    if (typeof raw === "string") {
      conditions[name] = raw;
      continue;
    }
    if (typeof raw === "number" || typeof raw === "boolean") {
      conditions[name] = String(raw);
      continue;
    }
    if (raw != null) {
      try {
        conditions[name] = JSON.stringify(raw);
      } catch {
        conditions[name] = String(raw);
      }
    }
  }
  return conditions;
}

export function stringifyUnknown(value: unknown): string {
  if (value == null) {
    return "";
  }
  if (typeof value === "string") {
    return value;
  }
  if (typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }
  try {
    return JSON.stringify(value);
  } catch {
    return "";
  }
}

export function extractFlexibleListRows(response: unknown): unknown[] {
  if (Array.isArray(response)) {
    return response;
  }
  if (response == null || typeof response !== "object") {
    return [];
  }
  const record = response as Record<string, unknown>;
  for (const key of ["data", "rows", "results", "items", "findings"]) {
    const value = record[key];
    if (Array.isArray(value)) {
      return value;
    }
  }
  const payload = record.data;
  if (payload != null && typeof payload === "object" && !Array.isArray(payload)) {
    const nested = payload as Record<string, unknown>;
    for (const key of ["data", "rows", "results", "items", "findings"]) {
      const value = nested[key];
      if (Array.isArray(value)) {
        return value;
      }
    }
  }
  return [];
}
